"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRiskLocationDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
class OpportunityRiskLocationDto {
    constructor(addressId) {
        this.addressId = addressId;
    }
}
exports.OpportunityRiskLocationDto = OpportunityRiskLocationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Address ID", example: 1001 }),
    (0, class_validator_1.IsNotEmpty)({ message: "Address ID is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Address ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRiskLocationDto.prototype, "addressId", void 0);
